import React from 'react';
import PropTypes from 'prop-types';
import REQUIRED_FIELDS from '@/pages/projects/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/states-year/MetricLoader';
import DeltaMetric from '@/pages/states-year/DeltaMetric';
import { site_state_$ilike } from '@/utils/query-helpers';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

StudentsYear.propTypes = {
  state: PropTypes.string,
  network: PropTypes.shape({
    id: PropTypes.number
  }),
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool
};

export default function StudentsYear(props) {
  const { state, schoolStart, schoolEnd, titleOnly } = props;

  const allProjects = usePagedQuery('projects', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd
          }
        }
      }
    }
  }, { source: 'states-year/Projects/StudentsYear/allProjects', message: STUDENT_IMPACT_MESSAGE });

  const newProjects = usePagedQuery('projects', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    }
  }, { source: 'states-year/Projects/StudentsYear/newProjects', message: STUDENT_IMPACT_MESSAGE });

  if (
    allProjects.state === PayloadStates.FETCHING ||
    newProjects.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Students Impacted"
      />
    );
  }

  const totalCount = sumActualStudents(allProjects.data);

  const newCount = sumActualStudents(newProjects.data);

  return (
    <DeltaMetric
      name="Students Impacted"
      value={totalCount}
      delta={newCount}
      titleOnly={titleOnly}
    />
  );
}
